import { CALL_API_METHODS } from "repoV2/constants/apis";
import { callApi } from "repoV2/utils/common/api/callApi";
import { appendURLSearchParams } from "repoV2/utils/urls&routing/urlParams";
import { payment_api } from "../Payments.constants";
import {
    IGetTransactionDetailsApiResponse,
    ITransactionDetails,
} from "../Payments.interface";

/**
 * Given a transaction id, we get the booking details for that transaction
 * Booking details refer to the details that the user fill at the time of making
 * the purchase of the listing for which transaction is done
 * @param param0 transactionId - the transaction for which booking details needs to be get
 * @returns Object containing transaction details - order (user basic details) and the
 * booking_questions (custom questions answers)
 */
export const callGetTransactionDetailsApi = ({
    transactionId,
}: {
    transactionId: string;
}) =>
    callApi({
        url: `${payment_api.get_transaction_details}${appendURLSearchParams(
            "",
            {
                order_uid: transactionId,
            }
        )}`,
        method: CALL_API_METHODS.GET,
        extraOptions: {
            appendExlyBackendHeaders: true,
        },
    }).then((response: IGetTransactionDetailsApiResponse) => {
        const transactionData: ITransactionDetails = response?.data?.data;

        return transactionData;
    });
